import { fetcher } from '@commenda/utils';

import type {
  IFilingsAuditorMutationResult,
  ISubmitFilingsAuditorRunData,
} from './types';

export async function submitFilingsAuditorRun(
  serviceRequestId: string,
  force = false
): Promise<IFilingsAuditorMutationResult<ISubmitFilingsAuditorRunData>> {
  try {
    const response = await fetcher('agent-platform/filings-auditor/runs', {
      method: 'POST',
      body: { serviceRequestId, force },
    });
    if (!response.ok)
      return { success: false, error: 'Failed to start audit run.' };
    const data: { run: ISubmitFilingsAuditorRunData } = await response.json();
    return { success: true, data: data.run };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to start audit run.',
    };
  }
}
